import api from "../api"
import { TYPE_FETCHING } from "../constants"

export const getTemplateTaskApi = (id_measure) =>
  api(`action-plans/tasks/${id_measure}/export/`, TYPE_FETCHING.get)
